import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_19 = { class: "form-group d-flex flex-wrap" }
const _hoisted_20 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_21 = { class: "d-flex align-items-center flex-row mb-5" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_24 = { class: "mb-10" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "svg-icon svg-icon-3" }
const _hoisted_27 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_29 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_30 = { class: "indicator-label" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_32 = { class: "indicator-progress" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_34 = { class: "card mb-5 mb-xl-10" }
const _hoisted_35 = { class: "card-header border-0" }
const _hoisted_36 = { class: "card-title m-0" }
const _hoisted_37 = { class: "fw-boldest m-0" }
const _hoisted_38 = { class: "card-body border-top p-9" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group d-flex flex-wrap" }
const _hoisted_42 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_43 = { class: "el-form-item__content" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group d-flex flex-wrap" }
const _hoisted_46 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_47 = { class: "el-form-item__content" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group d-flex flex-wrap" }
const _hoisted_50 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_51 = { class: "el-form-item__content" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group d-flex flex-wrap" }
const _hoisted_54 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_55 = { class: "el-form-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("common.information")), 1)
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("standardOperatingProcedure.subject")), 1),
                  _createVNode(_component_el_form_item, { prop: "subject" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.subject,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.subject) = $event)),
                        type: "text",
                        placeholder: _ctx.t('common.plsEnter')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("standardOperatingProcedure.systemStatus")), 1),
                  _createVNode(_component_el_form_item, { prop: "system_status" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.formData.system_status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.system_status) = $event)),
                        "active-value": 10,
                        "inactive-value": 25
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("standardOperatingProcedure.type")), 1),
                  _createVNode(_component_el_form_item, { prop: "type" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.formData.type,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.type) = $event)),
                        clearable: "",
                        placeholder: _ctx.t('common.plsSelect'),
                        loading: _ctx.typeLoading,
                        style: {"width":"100%"},
                        onChange: _ctx.typeChange
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder", "loading", "onChange"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.formData.type != 1 && _ctx.formData.type != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("standardOperatingProcedure.applyTo")), 1),
                      _createVNode(_component_el_form_item, { prop: "apply_to" }, {
                        default: _withCtx(() => [
                          (_ctx.formData.type == 2)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 0,
                                modelValue: _ctx.formData.apply_to,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.apply_to) = $event)),
                                multiple: "",
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                loading: _ctx.applyToLoading,
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ouickInquiryApplyToOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "loading"]))
                            : _createCommentVNode("", true),
                          (_ctx.formData.type == 3)
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: _ctx.formData.apply_to,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.apply_to) = $event)),
                                multiple: "",
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                loading: _ctx.applyToLoading,
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.callOutApplyToOptions, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "loading"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h3", _hoisted_22, _toDisplayString(_ctx.t("standardOperatingProcedure.procedure")), 1),
              _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleAddProcedure && _ctx.handleAddProcedure(...args)))
              }, [
                _createElementVNode("span", _hoisted_23, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                ])
              ])), [
                [_directive_auth, { auth: ['update'] }]
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_el_table, {
                ref: "multipleTableRef",
                data: _ctx.formData.check_list,
                style: {"width":"100%"},
                size: "small",
                "show-header": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "ID",
                    width: "60"
                  }, {
                    default: _withCtx(({ $index }) => [
                      _createTextVNode(_toDisplayString($index + 1), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: _ctx.t('standardOperatingProcedure.checkList')
                  }, {
                    default: _withCtx(({ row }) => [
                      _createVNode(_component_el_input, {
                        modelValue: row.check_list,
                        "onUpdate:modelValue": ($event: any) => ((row.check_list) = $event),
                        type: "textarea",
                        placeholder: _ctx.t('common.plsEnter'),
                        onInput: ($event: any) => (_ctx.handleItemInputChange($event, row))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onInput"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _withDirectives((_openBlock(), _createBlock(_component_el_table_column, {
                    label: "",
                    width: "80",
                    align: "right"
                  }, {
                    default: _withCtx(({ $index, row }) => [
                      _createElementVNode("div", {
                        type: "button",
                        class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                        onClick: ($event: any) => (_ctx.handleDeleteProcedure($index, row))
                      }, [
                        _createElementVNode("span", _hoisted_26, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                        ])
                      ], 8, _hoisted_25)
                    ]),
                    _: 1
                  })), [
                    [_directive_auth, { auth: ['update'] }]
                  ])
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_component_router_link, {
              to: '/task-management/standard-operating-procedure/',
              class: "btn btn-secondary align-self-center me-2"
            }, {
              default: _withCtx(() => [
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
              ]),
              _: 1
            }),
            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_29, [
              _createElementVNode("span", _hoisted_30, [
                _hoisted_31,
                _createTextVNode(_toDisplayString(_ctx.t("common.saveChanges")), 1)
              ]),
              _createElementVNode("span", _hoisted_32, [
                _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                _hoisted_33
              ])
            ])), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.t("common.historyLog")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("common.creator")), 1),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.created_user,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.__show.created_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("common.creationDate")), 1),
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.created_at,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.created_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("common.lastModifiedBy")), 1),
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.__show.updated_user,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.__show.updated_user) = $event)),
                  type: "text",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("common.lastModifiedDate")), 1),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formData.updated_at,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.updated_at) = $event)),
                  type: "datetime",
                  style: {"width":"100%"},
                  disabled: ""
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ])
  ], 64))
}